import type { GattServer } from '@/ble/types';
import { subscribe } from '@/ble/gatt';
import { UUID } from '@/ble/uuids';
import { BleDeviceBase } from '../bleTrainerBase';
import { parseHeartRate } from './protocol';

/** Standard BLE heart rate strap (0x180D). */
export class HrSensor extends BleDeviceBase {
  readonly sensorKind = 'hr' as const;

  protected async setup(server: GattServer): Promise<void> {
    const svc = await server.getPrimaryService(UUID.HRS);
    const meas = await svc.getCharacteristic(UUID.HR_MEASUREMENT);
    this.unsubs.push(
      await subscribe(meas, (dv) => {
        const m = parseHeartRate(dv);
        this.emitData({ hrBpm: m.bpm });
      }),
    );
  }

  protected onTransportLost(): void {
    /* nothing to clean */
  }
}
